import React, { FunctionComponent, useState } from "react";

interface Props {
    handleClick: () => void;
    children: JSX.Element;
    isInitialArrowDown?: boolean;
}

export const ShowMoreButton: FunctionComponent<Props> = ({
    handleClick,
    children,
    isInitialArrowDown = true,
}) => {
    const [isArrowDown, setIsArrowDown] = useState(isInitialArrowDown);

    return (
        <div
            className="more-button"
            onClick={() => {
                handleClick();
                setIsArrowDown(!isArrowDown);
            }}
        >
            {children}
            <img src={"/assets/images/responsive/icons/chevron-down.svg"} alt="flèche"
                className={isArrowDown ? "" : "rotated"} />
        </div>
    );
};
